export { default as HeaderDesktop } from './HeaderDesktop';



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/HeaderDesktop/index.ts